// Constants: media types
export const MEDIA_TYPES = [
  { value: 'image', label: 'globals.images', extensions: ['jpg', 'jpeg', 'png', 'gif', 'WebP', 'svg'] },
  { value: 'video', label: 'globals.videos', extensions: ['mp4', 'mov', 'mpeg'] },
  { value: 'audio', label: 'globals.audios', extensions: ['m4a', 'mpeg-4', 'mp3', 'wav'] },
  { value: 'other', label: 'globals.others', extensions: ['doc', 'docx', 'pdf'] },
  { value: 'all', label: 'globals.all', extensions: [] },
];
